import { render } from "./VEDIOUPLOAD.vue?vue&type=template&id=3ded0ee4&scoped=true"
import script from "./VEDIOUPLOAD.vue?vue&type=script&lang=js"
export * from "./VEDIOUPLOAD.vue?vue&type=script&lang=js"

import "./VEDIOUPLOAD.vue?vue&type=style&index=0&id=3ded0ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ded0ee4"]])

export default __exports__